import { render, staticRenderFns } from "./dispatch_test.vue?vue&type=template&id=4ae7d29a&scoped=true&"
import script from "./dispatch_test.vue?vue&type=script&lang=js&"
export * from "./dispatch_test.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_test.vue?vue&type=style&index=0&id=4ae7d29a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7d29a",
  null
  
)

export default component.exports